 const baseTemplate =   {
      "image": {},
      "video": {},
      "icon": {},
      "simpleCard": {
        "showHeaderlabel": true,
        "showSubTitle": true,
        "title": {
          "tag": "All_Data_Types",
          "name": "TEXT_FIELD",
          "type": "text",
          "displayName": "Text Field",
         
        },
        "subTitle": {
          "tag": "All_Data_Types",
          "name": "TEXT_AREA_FIELD",
          "type": "textArea",
          "displayName": "Text Area Field",
        
        },
        "leftFooterField": {
          "tag": "All_Data_Types",
          "name": "TEXT_FIELD",
          "type": "text",
          "displayName": "Text Field",
         
        },
        "rightFooterField": {
          "tag": "All_Data_Types",
          "name": "DATE_TIME_FIELD",
          "type": "datetime",
          "displayName": "Date Time Field",
        }
      },
      "cardDesign": {
        "name": "Simple Card",
        "code": "simpleCardDesign"
      },
      "selectedField": [],
      "fields": [],
      "simplefields": [],
      "extraselectedField": []
    }

    export function generateCardViewTemplate(fields: any[]): any {
  const template = { ...baseTemplate };
  const nonSystemFields = fields.filter(f => f.tag !== 'System');

  const lowerIncludes = (str: string, keyword: string) =>
    str?.toLowerCase()?.includes(keyword.toLowerCase());

  // --- Title: first 'text' field with 'name' in name/displayName
  const titleField = nonSystemFields.find(
    f => f.type === 'text' && (lowerIncludes(f.name, 'name') || lowerIncludes(f.displayName, 'name'))
  );
  if (titleField) template.simpleCard.title = titleField;

  // --- Subtitle: first 'text' or 'textArea' that isn't the title
  const subTitleField = nonSystemFields.find(
    f =>
      (f.type === 'text' || f.type === 'textArea') &&
      f.name !== titleField?.name
  );
  if (subTitleField) template.simpleCard.subTitle = subTitleField;

  // --- Left Footer: field with 'status', or fallback to CREATED_BY from system
  const leftFooter =
    nonSystemFields.find(f => lowerIncludes(f.name, 'status') || lowerIncludes(f.displayName, 'status')) ||
    fields.find(f => f.name === 'CREATED_BY');
  if (leftFooter) template.simpleCard.leftFooterField = leftFooter;

  // --- Right Footer: first 'date' field, or fallback to LAST_MODIFIED_ON
  const rightFooter =
    nonSystemFields.find(f => f.type === 'date') ||
    fields.find(f => f.name === 'LAST_MODIFIED_ON');
  if (rightFooter) template.simpleCard.rightFooterField = rightFooter;

  return template;
}